/**
 * Utility per il rendering di markdown in HTML
 * Usata sia in admin che in frontend
 */
class MarkdownRenderer {
  /**
   * Renderizza testo markdown in HTML
   * @param {string} text - Testo markdown da convertire
   * @returns {string} HTML renderizzato
   */
  static render(text) {
    if (!text) return '';

    // Pulisci \n iniziali e finali
    text = text.replace(/^\n+/, '').replace(/\n+$/, '');

    return text
      // Headings: # H2, ## H3, ### H4, etc. (shift +1 level for compact rendering)
      .replace(/^(#{1,6})\s+(.+)$/gm, function(match, hashes, content) {
        const level = Math.min(hashes.length + 1, 6); // Shift +1, max h6
        return '<h' + level + ' style="margin: 0.5em 0; font-weight: bold;">' + content + '</h' + level + '>';
      })
      // Immagini: ![alt](url) -> <img>
      .replace(/!\[([^\]]*)\]\(([^)]+)\)/g, '<img src="$2" alt="$1" style="max-width: 100%; height: auto; margin: 10px 0; border-radius: 4px;">')
      // Link: [text](url) -> <a>
      .replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(match, text, url) {
        const isExternal = /^https?:\/\//.test(url) && !url.includes('italianway.house');
        const target = isExternal ? '_blank' : '_self';
        return '<a href="' + url + '" target="' + target + '" style="color: #0066cc; text-decoration: underline;">' + text + '</a>';
      })
      // Email: email@domain.com -> <a href="mailto:">
      .replace(/\b([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\b/g, '<a href="mailto:$1" style="color: #0066cc; text-decoration: underline;">$1</a>')
      // URL semplici: https://... o http://... (non dentro href o markdown link già processati)
      .replace(/(?<!")\bhttps?:\/\/[^\s<>"]+[^\s<>".,!?:;"']/g, function(url) {
        const target = url.includes('italianway.house') ? '_self' : '_blank';
        return '<a href="' + url + '" target="' + target + '" style="color: #0066cc; text-decoration: underline;">' + url + '</a>';
      })
      // Bold: **text** -> <strong> (non-greedy to handle nested asterisks)
      .replace(/\*\*([\s\S]+?)\*\*/g, '<strong>$1</strong>')
      // Codice: `text` -> <code>
      .replace(/`([^`]+)`/g, '<code style="background: #f5f5f5; padding: 2px 4px; border-radius: 3px;">$1</code>')
      // Paragrafi: doppi newline -> <p>
      .replace(/\n\n/g, '</p><p>')
      // Singoli newline -> <br>
      .replace(/\n/g, '<br>')
      // Wrappa in paragrafi se non vuoto
      .replace(/^(.+)$/s, '<p>$1</p>')
      // Pulisci paragrafi vuoti
      .replace(/<p><\/p>/g, '');
  }
}

export default MarkdownRenderer;
